import { render } from "./FeaturedServices.vue?vue&type=template&id=39e2b662&scoped=true&ts=true"
import script from "./FeaturedServices.vue?vue&type=script&lang=ts"
export * from "./FeaturedServices.vue?vue&type=script&lang=ts"

import "./FeaturedServices.vue?vue&type=style&index=0&id=39e2b662&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e2b662"]])

export default __exports__